import classNames from 'classnames';
import React from 'react';

const PostHeader = ({ date, postContentWrapperClassNames }) => {
    return (
        <div className={postContentWrapperClassNames}>
            <div className="post-header">
                <div className="post-date">{date}</div>
            </div>
        </div>
    );
};

export default PostHeader;
